/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Art_2_DetailInputs */

const en_svc_agents_art_2_detail = /** @type {(inputs: Svc_Agents_Art_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source and owner assigned`)
};

const lv_svc_agents_art_2_detail = /** @type {(inputs: Svc_Agents_Art_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avots un atbildīgais piešķirti`)
};

/**
* | output |
* | --- |
* | "Source and owner assigned" |
*
* @param {Svc_Agents_Art_2_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_art_2_detail = /** @type {((inputs?: Svc_Agents_Art_2_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Art_2_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_art_2_detail(inputs)
	return en_svc_agents_art_2_detail(inputs)
});